var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebFooterXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0396 36.6004H17.9604C8.05714 36.6004 0 28.5409 0 18.6348V18.5555C0 8.64934 8.05714 0.589844 17.9604 0.589844H18.0396C27.9429 0.589844 36 8.64934 36 18.5555V18.6348C36 28.5409 27.9429 36.6004 18.0396 36.6004ZM17.9604 1.80877C8.72857 1.80877 1.21856 9.32097 1.21856 18.5555V18.6348C1.21856 27.8693 8.72857 35.3815 17.9604 35.3815H18.0396C27.2714 35.3815 34.7814 27.8693 34.7814 18.6348V18.5555C34.7814 9.32097 27.2714 1.80877 18.0396 1.80877H17.9604Z",
    fill: "#059669"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66325 9.07617L15.6838 19.8027L7.61328 28.5241H9.43016L16.4966 20.8888L22.2056 28.5241H28.3873L19.9159 17.1942L27.4283 9.07617H25.6115L19.1043 16.1082L13.8462 9.07617H7.66445H7.66325ZM10.3343 10.4146H13.1736L25.7138 27.1857H22.8746L10.3343 10.4146Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebFooterXIcon);
export default __webpack_public_path__ + "static/media/web_footer_X_icon.e3019bc1a6ebcc018bd9e5440110a89b.svg";
export { ForwardRef as ReactComponent };